var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocreader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.371 1.236A143.467 143.467 0 015.086 4.49c-.18.17-.482.291-.733.311-.754.05-1.507.01-2.25.07-1.327.1-1.92.633-2.05 1.95-.04.401-.05.803-.05 1.205-.01.402.01.804.05 1.206.12 1.316.723 1.848 2.05 1.949.753.06 1.506.01 2.25.07.25.02.552.13.733.311 1.115 1.065 2.21 2.15 3.285 3.256 1.206 1.245 2.713 1.165 4.25 1.024V8.037.06c-1.547-.16-3.044-.07-4.25 1.176zM16.208 1.651L16.98.164S21 2.454 21 8.041c0 5.596-4.069 7.665-4.069 7.665l-.723-1.406s3.195-2 3.195-6.22c0-4.219-3.195-6.429-3.195-6.429z",
    fill: "#1B143C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.821 4.562l.764-1.507s2.35 1.748 2.35 5.033-2.36 4.812-2.36 4.812l-.754-1.517s1.517-1.165 1.517-3.285c.01-2.13-1.517-3.536-1.517-3.536z",
    fill: "#1B143C"
  })));
}
export default SvgDocreader;